// extracted by mini-css-extract-plugin
export default {"summary":"Summary-module__summary__qEgi5","content":"Summary-module__content__AmpM+","title":"Summary-module__title__9FXwz"};